export default __webpack_public_path__ + "static/media/live-agent-node.41ace875.svg";